import { Anchor, Button, Divider, Stack, Text } from '@mantine/core';
import { IconBrandGoogle, IconBrandWindows } from '@tabler/icons-react';
import { Trans, useTranslation } from 'react-i18next';
import { useSystemInfo } from '@/api/system';
import { legalLinks } from '@/lib/legal';

const PROVIDERS: Record<string, { label: string; icon: typeof IconBrandGoogle }> = {
  google: { label: 'Google', icon: IconBrandGoogle },
  microsoft: { label: 'Microsoft', icon: IconBrandWindows },
};

/** Anmeldung über konfigurierte OAuth-Anbieter (SEC-02); erscheint nur, wenn welche aktiv sind. */
export function OAuthButtons() {
  const { t, i18n } = useTranslation();
  const { data } = useSystemInfo();
  const legal = legalLinks(i18n.language);
  const providers = data?.loginProviders ?? [];
  if (providers.length === 0) return null;
  return (
    <Stack gap="xs">
      <Divider label={t('login.or')} labelPosition="center" />
      {providers.map((id) => {
        const p = PROVIDERS[id] ?? { label: id, icon: IconBrandGoogle };
        return (
          <Button key={id} component="a" href={`/oauth2/authorization/${id}`} variant="default" leftSection={<p.icon size={18} />} fullWidth>
            {t('login.continueWith', { provider: p.label })}
          </Button>
        );
      })}
      <Text size="xs" c="dimmed" ta="center">
        <Trans
          i18nKey="login.oauthTerms"
          components={{
            terms: <Anchor href={legal.terms} target="_blank" rel="noopener" inherit />,
            privacy: <Anchor href={legal.privacy} target="_blank" rel="noopener" inherit />,
          }}
        />
      </Text>
    </Stack>
  );
}
